import {
  type CurrentDeviceContextSnapshot,
  projectCurrentDeviceContextHeaders,
} from '@automatick/shared-ts';

export function appendCurrentDeviceRealtimeQuery(
  url: string,
  currentDeviceContext?: CurrentDeviceContextSnapshot,
): string {
  if (!currentDeviceContext) {
    return url;
  }

  const entries = projectCurrentDeviceContextHeaders(currentDeviceContext);
  try {
    const absoluteUrl = new URL(url);
    appendEntries(absoluteUrl.searchParams, entries);
    return absoluteUrl.toString();
  } catch {
    return appendRelativeUrlEntries(url, entries);
  }
}

function appendRelativeUrlEntries(
  url: string,
  entries: ReturnType<typeof projectCurrentDeviceContextHeaders>,
): string {
  const fragmentIndex = url.indexOf('#');
  const routeAndQuery = fragmentIndex >= 0 ? url.slice(0, fragmentIndex) : url;
  const fragment = fragmentIndex >= 0 ? url.slice(fragmentIndex) : '';
  const queryIndex = routeAndQuery.indexOf('?');
  const route =
    queryIndex >= 0 ? routeAndQuery.slice(0, queryIndex) : routeAndQuery;
  const existingQuery =
    queryIndex >= 0 ? routeAndQuery.slice(queryIndex + 1) : '';
  const params = new URLSearchParams(existingQuery);
  appendEntries(params, entries);

  return `${route}?${params.toString()}${fragment}`;
}

function appendEntries(
  params: URLSearchParams,
  entries: ReturnType<typeof projectCurrentDeviceContextHeaders>,
): void {
  for (const [name, value] of entries) {
    params.set(name, value);
  }
}
